import { render } from "./MaterialSelectPage.vue?vue&type=template&id=5acc7f14&scoped=true"
import script from "./MaterialSelectPage.vue?vue&type=script&lang=js"
export * from "./MaterialSelectPage.vue?vue&type=script&lang=js"

import "./MaterialSelectPage.vue?vue&type=style&index=0&id=5acc7f14&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5acc7f14"]])

export default __exports__